import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import Table from 'react-bootstrap/Table';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import filterFactory from 'react-bootstrap-table2-filter';

import UIUtils from "../util/UIUtils";
import UITableUtils from "../util/UITableUtils";
import RespUtils from '../util/RespUtils';
import ApiUtils from '../util/ApiUtils';
import "./OasisPools.css";
import Utilities from "../util/Utilities";
import SPUtilities from "../util/SPUtilities";
import FavUtils from "../util/FavUtils";
import LogoUtils from "../util/LogoUtils";

import CollapsibleNote from "../base/CollapsibleNote";
import OasisNotes from "../oasis/OasisNotes";
import OasisUtils from "../oasis/OasisUtils";
import OasisPoolInline from "../oasis/OasisPoolInline";
import Special from '../components/Special';

class OasisPools extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      pools: [],
      statusSummary: {"AllVal": 0, "InConsensus": 0, "NotInConsensus": 0},
      blockHeight: 0,
      coinStat: {},
      width: window.innerWidth,
      size: 10,
      oasisChainId: "",
      lastUpdated: "",
    }
    // this.switchView = this.switchView.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
    this.favourite = this.favourite.bind(this);
    this.unfavourite = this.unfavourite.bind(this);
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  componentWillMount() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  async componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);

    // var poolId = UIUtils.getPoolId(this);

    // const poolData = await ApiUtils.get("listOasisPools?sortBy=stake");
    let url = "listData?type=oasisPools"
    // const nodeData = await ApiUtils.get("listValidators?sortBy=stake");
    if (this.props.match && this.props.match.params.selectedInd) {
      url += "&selectedInd=" + this.props.match.params.selectedInd;
    } else {
      url += "&selectedInd=True";
    }

    const allData = await ApiUtils.get(url);
    if (!allData) {
      this.setState({error: true, isLoading: false});
      return;
    }

    // console.log(allData)
    let poolData = allData["data"];
    let statusSummary = allData["statusSummary"];
    let lastUpdated = allData["lastUpdated"];
    let votingPower = allData["votingPower"];
    let blockHeight = allData["oasisBlockHeight"];
    let oasisChainId = allData["oasisChainId"];
    // let prevPhaseBlockHeight = allData["prevPhaseBlockHeight"];
    // let coinStats = allData["coinStats"];
    if (poolData) {
      // console.log("poolData: ", poolData)
      let newData = Utilities.addIndex(poolData);
      FavUtils.filterData(this, newData);

      let newLastUpdated = lastUpdated;
      if (lastUpdated == null) {
        newLastUpdated = 0;
      }

      let notification = allData["notification"];
      // let totalBlockHeight = parseInt(blockHeight) + parseInt(prevPhaseBlockHeight);
      this.setState({lastUpdated: newLastUpdated, votingPower: votingPower,
        blockHeight: blockHeight, oasisChainId: oasisChainId, notification: notification,
        statusSummary: statusSummary, coinStat: allData["coinStat"]});
    }

    // this.setState({coinStats: coinStats, isLoading: false});
    this.setState({isLoading: false});
  }

  unfavourite(e) {
    FavUtils.unfavourite(e, this);
  }

  favourite(e) {
    FavUtils.favourite(e, this);
  }

  render() {
    let loadMsg = UIUtils.getLoading(this);
    if (loadMsg) return loadMsg;
    // if (this.state.isLoading) {
    //   return <div>Loading</div>;
    // }
    // console.log("this.state.coinStats.totalStake: ", this.state.coinStats.totalStake);
    // console.log("pool data is:", this.state);
    // var maxSigns = Utilities.getMaxValueForAttribute(this.state.pools, "signatures");
    // var maxAvail = Utilities.getMaxValueForAttribute(this.state.pools, "availabilityScore");
    // console.log("maxSigns: ", maxSigns);

    var columns;
    if (RespUtils.isMobileView()) {
      columns = [
        {text: "#",dataField: "index", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(8)},
        {text: "",dataField: "poolId", sort: true, formatter: FavUtils.favoriteFormatter, formatExtraData: this, headerStyle: Utilities.width(8)},
        {text: "Validator", dataField: "entityName", formatter: OasisUtils.entityFormatter, sort: true,  headerStyle: Utilities.width(39)},
        {text: "Escrow", dataField: "total", formatter: SPUtilities.moneyFormatter, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(20)},
        {text: "Daily Sign", dataField: "dailyPerSigned", formatter: OasisUtils.signFormatter, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(20)},
      ];
    } else if (RespUtils.isTabletView()) {
      columns = [
        {text: "#",dataField: "index", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(3)},
        {text: "",dataField: "poolId", sort: true, formatter: FavUtils.favoriteFormatter, formatExtraData: this, headerStyle: Utilities.width(4)},
        {text: "",dataField: "idAddress", sort: true, formatter: LogoUtils.formatLogo, headerStyle: Utilities.width(3)},
        {text: "Validator", dataField: "entityName", formatter: OasisUtils.entityFormatter, sort: true, headerStyle: Utilities.width(18)},
        // {text: "", dataField: "idAddress", filter: textFilter({placeholder: "Address"}), formatter: AddressUtils.addressFormatter, sort: true, headerStyle: Utilities.width(25)},
        // {text: "", dataField: "publicKey", filter: textFilter({placeholder: "Public Key"}), formatter: AddressUtils.addressFormatter, sort: true, headerStyle: Utilities.width(25)},
        {text: "Escrow", dataField: "total", formatter: SPUtilities.stakeFormatterRounded, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(10)},
        {text: "Commission", dataField: "commission", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(12)},
        {text: "Current Sign", dataField: "currentPerSigned", formatter: OasisUtils.signFormatter, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(12)},
        {text: "Average Sign", dataField: "longPerSigned", formatter: OasisUtils.signFormatter, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(12)},
      ];
    } else {
      columns = [
        {text: "#",dataField: "index", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(2)},
        {text: "",dataField: "poolId", sort: true, formatter: FavUtils.favoriteFormatter, formatExtraData: this, headerStyle: Utilities.width(2)},
        {text: "",dataField: "idAddress", sort: true, formatter: LogoUtils.formatLogo, headerStyle: Utilities.width(2)},
        {text: "Validator", dataField: "entityName", formatter: OasisUtils.entityFormatter, sort: true, headerStyle: Utilities.width(10)},
        // {text: "", dataField: "idAddress", filter: textFilter({placeholder: "Address"}), formatter: AddressUtils.addressFormatter, sort: true, headerStyle: Utilities.width(13)},
        // {text: "", dataField: "publicKey", filter: textFilter({placeholder: "Public Key"}), formatter: AddressUtils.addressFormatter, sort: true, headerStyle: Utilities.width(13)},
        {text: "Escrow", dataField: "total", formatter: SPUtilities.stakeFormatterRounded, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(8)},
        // {text: "Delegates", dataField: "uniqueDelegates", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(6)},
        {text: "Commission", dataField: "commission", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(6)},
        {text: "Stake Weight", dataField: "stakeWeight", formatter: SPUtilities.percentFormatter, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(6)},
        {text: "Current Sign %", dataField: "currentPerSigned", formatter: OasisUtils.signFormatter, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(6)},
        {text: "Short Term Sign %", dataField: "shortPerSigned", formatter: OasisUtils.signFormatter, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(8)},
        {text: "Daily Sign %", dataField: "dailyPerSigned", formatter: OasisUtils.signFormatter, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(8)},
        {text: "Long Term Sign %", dataField: "longPerSigned", formatter: OasisUtils.signFormatter, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(7)},
        {text: "Latest Signed", dataField: "longLatestSigned", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(7)},
        {text: "Latest Proposed", dataField: "longLatestProposed", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(8)},
      ];
    }
    // {text: "ID", dataField: "idAddress", formatter: SPUtilities.addressLabelFormatter, sort: true, headerStyle: Utilities.width(35)},

    const options = {
      onlyOneExpanding: true
    };

    let wrapperClasses = UITableUtils.isDefaultView() ? "table":"table-responsive";
    let specialMessage = RespUtils.getSpecialMessage();

    const expandRow = {
      renderer: row => (
        <div>
          <OasisPoolInline pool={row}/>
          <hr/>
        </div>
      ), showExpandColumn: false
    };

    // const defaultSorted = [{
    //   dataField: 'signRate24Hrs',
    //   order: 'desc' // desc or asc
    // }];
    // defaultSorted={defaultSorted}
    const rowStyle = (row, rowIndex) => {
      // console.log(row.selectedInd);
      if (row.selectedInd == 'False') {
         return { backgroundColor: 'oldlace' };
      }

      // if (row.signRate21Days == 0) {
      //    return { backgroundColor: 'darkgray' };
      // }
      //
      if (FavUtils.isFavourite(row.poolId)) {
        return { backgroundColor: 'gainsboro' };
      }
    };

    // <th>Active Accounts</th>
    // <td>{this.state.coinStat.activeAccounts}</td>
    // <th>Unique Delegates</th>
    // <td>{this.state.coinStat.uniqueDelegates}</td>
    return (
      <div>
        <Special />
        <p/>
        <h4 style={{align: "center"}}><span><strong>Validators</strong></span>
            {UIUtils.renderPageActions(this, true, true)}
        </h4>
        {SPUtilities.getLastUpdated(this, false)}
        {UIUtils.getNotification(this.state.notification)}
        <p/>
        <Table bordered hover variant="dark" size="sm" >
          <tbody>
            <tr>
              <th>Total Staked</th>
              <td>{SPUtilities.coinCountCellFormatter(this.state.coinStat.totalStake)}</td>
              <th>Block Height</th>
              <td>{this.state.blockHeight}</td>
            </tr>
            <tr>
              <th>Median Commission</th>
              <td>{this.state.coinStat.medianFee}</td>
              <th>Epoch</th>
              <td>{this.state.coinStat.currentEpoch}</td>
            </tr>
          </tbody>
        </Table>
        {this.renderStatusTags()}
        <BootstrapTable keyField='index' data={ this.state.pools } filter={ filterFactory() }
          columns={ columns } striped expandRow={ expandRow } striped hover bordered
          expandableRow={ () => { return true; } }  rowStyle={rowStyle}
          condensed noDataIndication="Table is Empty/Loading" wrapperClasses={wrapperClasses}
          />
        <p/>
        <CollapsibleNote getScreenGuide={OasisNotes.getPoolNote} />
        {specialMessage}
      </div>
    );
  }

  // static gapFromTop(cell, row, rowIndex, formatExtraData) {
  //   if (isNaN(cell) || isNaN(formatExtraData)) {
  //     return "N/A";
  //   }
  //
  //   return formatExtraData - cell;
  // }

  // switchView() {
  //   UITableUtils.switchView();
  // }

  renderStatusTags() {
    if (this.state.isLoading) return "";

    if (RespUtils.isMobileView()) {
      return (<div><table><tbody><tr>
          <td className="view-tag"><a className="black-a" href={"/pools/AllVal"}>{this.formatView("All ", this.state.statusSummary.AllVal, "AllVal")}</a> </td>
          <td className="view-tag"><a className="black-a" href={"/pools/True"}>{this.formatView("In Cons. ", this.state.statusSummary.InConsensus, "True")}</a> </td>
          <td className="view-tag"><a className="black-a" href={"/pools/False"}>{this.formatView("Not in Cons. ", this.state.statusSummary.NotInConsensus, "False")}</a> </td>
        </tr></tbody></table></div>);
    } else {
      return (<div><table><tbody><tr>
          <td className="view-tag"><a className="black-a" href={"/pools/AllVal"}>{this.formatView("All ", this.state.statusSummary.AllVal, "AllVal")}</a> </td>
          <td className="view-tag"><a className="black-a" href={"/pools/True"}>{this.formatView("In Consensus ", this.state.statusSummary.InConsensus, "True")}</a> </td>
          <td className="view-tag"><a className="black-a" href={"/pools/False"}>{this.formatView("Not in Consensus ", this.state.statusSummary.NotInConsensus, "False")}</a> </td>
        </tr></tbody></table></div>);
    }
  }
  // <td className="view-tag"><a href={"/pools/Inactive"}>{this.formatView("Inactive ", this.state.statusSummary.Inactive, "Inactive")}</a> </td>

  formatView(label, count, selectedInd) {
    if (count != null) {
      label = label + count;
    } else {
      label = label + "0";
    }
    // console.log("in formatView for: ", label, selectedInd);
    if (this.props.match && this.props.match.params.selectedInd) {
      // console.log(this.props.match.params.selectedInd, "-", selectedInd);
      if (this.props.match.params.selectedInd == selectedInd) {
        // console.log("selectedInd matched: ", this.props.match.params.selectedInd);
        return <b><u>{label}</u></b>
      } else {
        return label;
      }
    } else if (selectedInd == "True") {
      // console.log("returning from AllEligible");
      return <b><u>{label}</u></b>
    } else if (selectedInd != null) {
      // console.log("returning from status not null");
      return label;
    }

    // console.log("returning from end");
    return <b><u>{label}</u></b>
  }
}
// <tr>
//   <th>Voting power</th>
//   <td>{this.state.votingPower}</td>
// </tr>
// <p>**** Note - initial data loaded may skew some of the larger windows. It will get corrected as data is accrued over time.</p>
// <p>Availability Score = Signatures + (50 * Proposals)</p>
// <tr>
//   <th>Total Block Height</th>
//   <td>{this.state.totalBlockHeight} (all phases)</td>
// </tr>

export default OasisPools;



// WEBPACK FOOTER //
// ./src/network/OasisPools.js